/**
 * PERSONNALISATIONS JS POUR JM LEGAZEL
 * ====================================
 * Ce fichier contient toutes les personnalisations JavaScript
 * pour la boutique Shopify JM Legazel.
 * Dernière mise à jour : 20 mai 2025
 */

/**
 * FILTRE AUTOMATIQUE "EN STOCK" POUR THEME IMPULSE
 * Spécifiquement adapté à la structure des filtres du thème Impulse de Shopify
 */
document.addEventListener('DOMContentLoaded', function() {
  // Vérifier si nous sommes sur une page de collection "fins de séries"
  const currentUrl = window.location.pathname;
  if (currentUrl.includes('/collections/') && 
      (currentUrl.includes('fins-de-series') || 
       currentUrl.includes('fins-de-series-homme') || 
       currentUrl.includes('fins-de-series-femme'))) {
    
    // console.log("Page de collection Fins de Séries détectée - Thème Impulse");
    
    // Fonction pour trouver et cocher le filtre "en stock"
    function findAndCheckStockFilter() {
      // console.log("Tentative de trouver le filtre 'en stock'...");
      
      // Dans le thème Impulse, le texte du filtre est dans un span.tag__text
      const tagTextElements = document.querySelectorAll('.tag__text');
      let stockFilterFound = false;
      
      // console.log("Nombre d'éléments .tag__text trouvés:", tagTextElements.length);
      
      // Parcourir tous les éléments .tag__text pour trouver celui qui contient "en stock"
      for (const textElement of tagTextElements) {
        // console.log("Texte de l'élément:", textElement.textContent.trim());
        
        if (textElement.textContent.trim().toLowerCase() === 'en stock' || 
            textElement.textContent.trim().toLowerCase().includes('stock')) {
          // console.log("Filtre 'en stock' trouvé:", textElement);
          
          // Remonter jusqu'à l'élément parent qui contient le checkbox
          let label = textElement.closest('.tag__checkbox-wrapper');
          if (label) {
            // Trouver le checkbox à l'intérieur du label
            const checkbox = label.querySelector('input[type="checkbox"]');
            if (checkbox) {
              // console.log("Checkbox 'en stock' trouvée:", checkbox);
              checkbox.checked = true;
              
              // Déclencher les événements pour activer le filtre
              checkbox.dispatchEvent(new Event('change', { bubbles: true }));
              
              stockFilterFound = true;
              // console.log("Filtre 'En stock' activé avec succès!");
              break;
            }
          }
        }
      }
      
      // Si la première méthode n'a pas fonctionné, essayer de rechercher dans les labels
      if (!stockFilterFound) {
        // console.log("Recherche dans les éléments label...");
        
        const allLabels = document.querySelectorAll('label');
        // console.log("Nombre de labels trouvés:", allLabels.length);
        
        for (const label of allLabels) {
          if (label.textContent.toLowerCase().includes('stock')) {
            // console.log("Label contenant 'stock' trouvé:", label);
            
            const checkbox = label.querySelector('input[type="checkbox"]');
            if (checkbox) {
              // console.log("Checkbox trouvée via label:", checkbox);
              checkbox.checked = true;
              checkbox.dispatchEvent(new Event('change', { bubbles: true }));
              
              stockFilterFound = true;
              // console.log("Filtre activé avec succès via label!");
              break;
            }
          }
        }
      }
      
      // Si toujours pas trouvé, essayer avec tous les éléments qui contiennent du texte
      if (!stockFilterFound) {
        // console.log("Recherche dans tous les éléments de texte...");
        
        // Sélectionner tous les éléments qui pourraient contenir le texte du filtre
        const allTextElements = document.querySelectorAll('span, div, p, a, li');
        
        for (const element of allTextElements) {
          if (element.textContent && 
              element.textContent.trim().toLowerCase().includes('stock') &&
              element.textContent.length < 30) { // Éviter les longs blocs de texte
            
            // console.log("Élément contenant 'stock' trouvé:", element);
            
            // Essayer de trouver une checkbox à proximité
            // 1. Chercher dans l'élément lui-même
            let checkbox = element.querySelector('input[type="checkbox"]');
            
            // 2. Chercher dans le parent immédiat
            if (!checkbox && element.parentNode) {
              checkbox = element.parentNode.querySelector('input[type="checkbox"]');
            }
            
            // 3. Remonter jusqu'à 3 niveaux
            if (!checkbox) {
              let parent = element.parentNode;
              for (let i = 0; i < 3; i++) {
                if (parent) {
                  checkbox = parent.querySelector('input[type="checkbox"]');
                  if (checkbox) break;
                  parent = parent.parentNode;
                }
              }
            }
            
            if (checkbox) {
              // console.log("Checkbox trouvée près de l'élément:", checkbox);
              checkbox.checked = true;
              checkbox.dispatchEvent(new Event('change', { bubbles: true }));
              
              stockFilterFound = true;
              // console.log("Filtre activé avec succès via recherche générique!");
              break;
            }
          }
        }
      }
      
      return stockFilterFound;
    }
    
    // Fonction pour attendre les filtres et observer les changements dans le DOM
    function waitForFilters() {
      // Regarder si les filtres sont déjà chargés
      const filterContainer = document.querySelector('.collection-sidebar') || 
                             document.querySelector('#CollectionSidebar');
      
      if (filterContainer && filterContainer.querySelectorAll('input[type="checkbox"]').length > 0) {
        // console.log("Filtres détectés, tentative d'activation du filtre 'en stock'...");
        return findAndCheckStockFilter();
      }
      
      return false;
    }
    
    // Configuration d'un observateur pour surveiller les changements du DOM
    function setupMutationObserver() {
      // console.log("Configuration d'un observateur pour les filtres...");
      
      const observeTarget = document.querySelector('#CollectionSidebar') || 
                           document.querySelector('.collection-sidebar') || 
                           document.body;
      
      const observer = new MutationObserver(function(mutations) {
        for (const mutation of mutations) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            setTimeout(function() {
              const found = findAndCheckStockFilter();
              if (found) {
                observer.disconnect();
                // console.log("Filtre trouvé et coché après chargement dynamique!");
              }
            }, 100);
          }
        }
      });
      
      // Observer les modifications du DOM
      observer.observe(observeTarget, { 
        childList: true, 
        subtree: true 
      });
      
      // Déconnecter l'observateur après 15 secondes
      setTimeout(function() {
        observer.disconnect();
        // console.log("Observateur de mutations déconnecté après délai maximal.");
      }, 15000);
      
      return observer;
    }
    
    // Séquence de tentatives
    // console.log("Démarrage de la séquence de recherche du filtre 'en stock'...");
    
    // 1. Première tentative immédiate
    let found = waitForFilters();
    
    if (!found) {
      // 2. Deuxième tentative après 500ms
      setTimeout(function() {
        found = waitForFilters();
        
        if (!found) {
          // 3. Troisième tentative après 1.5s
          setTimeout(function() {
            found = waitForFilters();
            
            if (!found) {
              // 4. Configurer l'observateur de mutations
              const observer = setupMutationObserver();
              
              // 5. Tentatives supplémentaires à intervalles réguliers
              [3000, 5000, 7000, 10000].forEach(function(delay) {
                setTimeout(function() {
                  if (!found) {
                    found = findAndCheckStockFilter();
                    if (found && observer) {
                      observer.disconnect();
                    }
                  }
                }, delay);
              });
            }
          }, 1500);
        }
      }, 500);
    }
  } else {
    // console.log("Pas sur une page de collection Fins de Séries");
  }
});

// Mise en évidence des quantités en stock sur la page "fins de séries"
(function() {
  // Attendre que le DOM soit chargé
  document.addEventListener('DOMContentLoaded', function() {
    // Vérifie si nous sommes sur la page "fins de séries"
    var isFinsDeSeries = false;
    
    // Vérification via l'URL
    if (window.location.pathname.includes('/collections/fins-de-series') || 
        window.location.pathname.includes('/collections/fins-de-serie') || 
        window.location.pathname.includes('/collections/end-of-series')) {
      isFinsDeSeries = true;
    }
    
    // Vérification via le titre de la page (méthode alternative)
    var pageTitle = document.title || '';
    if (pageTitle.toLowerCase().includes('fins de série') || 
        pageTitle.toLowerCase().includes('fins de series')) {
      isFinsDeSeries = true;
    }
    
    // Si ce n'est pas la page fins de séries, on s'arrête là
    if (!isFinsDeSeries) {
      return;
    }
    
    // Fonction qui s'exécute périodiquement pour attraper les nouveaux éléments
    function updateStockNumbers() {
      // Cible spécifiquement le texte des tailles, pas les labels entiers
      var sizeTextElements = document.querySelectorAll('.filter-group__item span, .tag__text');
      
      // Pour chaque élément
      sizeTextElements.forEach(function(element) {
        // Ne traite que les éléments qui n'ont pas encore été modifiés
        if (!element.hasAttribute('data-processed') && element.textContent.includes('(')) {
          // Marque l'élément comme traité
          element.setAttribute('data-processed', 'true');
          
          // Récupère le texte original
          var originalText = element.textContent;
          
          // Trouve l'index des parenthèses
          var openParenIndex = originalText.lastIndexOf('(');
          var closeParenIndex = originalText.lastIndexOf(')');
          
          if (openParenIndex !== -1 && closeParenIndex !== -1) {
            // Divise le texte en parties
            var beforeParen = originalText.substring(0, openParenIndex);
            var insideParen = originalText.substring(openParenIndex, closeParenIndex + 1);
            
            // Crée le nouveau contenu HTML sans toucher à la structure parent-enfant
            element.innerHTML = beforeParen + 
                               '<span style="display: inline-block; width: 4px;">&nbsp;</span>' + 
                               '<span style="font-weight: 700; color: #482c54;">' + insideParen + '</span>';
          }
        }
      });
    }
    
    // Exécute la fonction immédiatement
    updateStockNumbers();
    
    // Puis toutes les 500ms pour attraper les éléments chargés dynamiquement
    setInterval(updateStockNumbers, 500);
  });
})();



// Version corrigée - Miniatures Patines
function initPatinesThumbnails() {
  if (!window.location.pathname.includes('/collections/palette-patines')) return;
  
  function attachEvents() {
    document.addEventListener('mouseover', function(e) {
      if (e.target.classList.contains('product-thumbnail-mini')) {
        const thumb = e.target;
        const productContent = thumb.closest('.grid-product__content');
        if (!productContent) return;
        
        const mainImage = productContent.querySelector('.grid-product__image-mask img');
        if (!mainImage) return;
        
        // Sauvegarder les attributs originaux
        if (!mainImage.dataset.originalSrc) {
          mainImage.dataset.originalSrc = mainImage.src;
          mainImage.dataset.originalSrcset = mainImage.getAttribute('srcset') || '';
          mainImage.dataset.originalDataSrcset = mainImage.getAttribute('data-srcset') || '';
        }
        
        // Obtenir la nouvelle source
        const newSrc = thumb.getAttribute('data-full-src');
        if (newSrc) {
          // IMPORTANT: Supprimer srcset qui a la priorité sur src
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('data-srcset');
          
          // Changer la source
          mainImage.src = newSrc;
        }
      }
    });
    
    document.addEventListener('mouseout', function(e) {
      if (e.target.closest('.grid-product__content') && 
          !e.relatedTarget?.closest('.grid-product__content')) {
        const product = e.target.closest('.grid-product__content');
        const mainImage = product.querySelector('.grid-product__image-mask img');
        
        if (mainImage && mainImage.dataset.originalSrc) {
          // Restaurer tout
          mainImage.src = mainImage.dataset.originalSrc;
          
          if (mainImage.dataset.originalSrcset) {
            mainImage.setAttribute('srcset', mainImage.dataset.originalSrcset);
          }
          if (mainImage.dataset.originalDataSrcset) {
            mainImage.setAttribute('data-srcset', mainImage.dataset.originalDataSrcset);
          }
        }
      }
    });
  }
  
  attachEvents();
}

// Lancer dès que possible
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPatinesThumbnails);
} else {
  initPatinesThumbnails();
}


// Gestion des flèches de navigation (version avec indicateur)
document.addEventListener('DOMContentLoaded', function() {
  if (!window.location.pathname.includes('/collections/palette-patines')) return;
  
  document.querySelectorAll('.product-thumbnails-container').forEach(function(container) {
    const scrollContainer = container.querySelector('.product-thumbnails-patines');
    const leftArrow = container.querySelector('.thumbnail-arrow--left');
    const rightArrow = container.querySelector('.thumbnail-arrow--right');
    const indicator = container.querySelector('.thumbnail-indicator');
    const thumbnails = container.querySelectorAll('.product-thumbnail-mini');
    
    if (!scrollContainer || !leftArrow || !rightArrow) return;
    
    // Fonction pour mettre à jour l'interface
    function updateInterface() {
  leftArrow.disabled = scrollContainer.scrollLeft <= 0;
  rightArrow.disabled = scrollContainer.scrollLeft >= 
    scrollContainer.scrollWidth - scrollContainer.clientWidth - 5;
  
  if (indicator && thumbnails.length > 0) {
    // Calculer combien de vignettes sont réellement visibles
    const containerWidth = scrollContainer.clientWidth;
    const innerWidth = scrollContainer.querySelector('.thumbnails-inner').scrollWidth;
    const totalThumbs = thumbnails.length;
    
    // Méthode alternative : compter les vignettes visibles
    let visibleCount = 0;
    const containerRect = scrollContainer.getBoundingClientRect();
    
    thumbnails.forEach(thumb => {
      const thumbRect = thumb.getBoundingClientRect();
      if (thumbRect.left < containerRect.right && thumbRect.right > containerRect.left) {
        visibleCount++;
      }
    });
    
    const firstVisible = Math.floor(scrollContainer.scrollLeft / 65) + 1;
    const lastVisible = firstVisible + visibleCount - 1;
    
    indicator.textContent = `${firstVisible}-${lastVisible} / ${totalThumbs}`;
  }
}
    
  
    // Scroll au clic
// Dans la fonction de gestion des flèches, remplacez les lignes de scroll par :

leftArrow.addEventListener('click', function(e) {
  e.preventDefault();
  e.stopPropagation();
  
  // Calculer la largeur d'une page complète
  const containerWidth = scrollContainer.clientWidth;
  scrollContainer.scrollLeft -= containerWidth;
});

rightArrow.addEventListener('click', function(e) {
  e.preventDefault();
  e.stopPropagation();
  
  // Calculer la largeur d'une page complète
  const containerWidth = scrollContainer.clientWidth;
  scrollContainer.scrollLeft += containerWidth;
});
    
    scrollContainer.addEventListener('scroll', updateInterface);
    updateInterface();
  });
});

// Ouvrir le produit sur l'image cliquée
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('product-thumbnail-mini')) {
    e.preventDefault();
    e.stopPropagation();
    
    const thumb = e.target;
    const productLink = thumb.closest('.grid-product__link');
    
    if (productLink) {
      // Obtenir l'index de l'image
      const allThumbs = thumb.parentElement.querySelectorAll('.product-thumbnail-mini');
      const imageIndex = Array.from(allThumbs).indexOf(thumb);
      
      // Stocker l'index dans sessionStorage
      sessionStorage.setItem('selectedImageIndex', imageIndex);
      
      // Rediriger vers le produit
      window.location.href = productLink.href;
    }
  }
});

// Sur la page produit, afficher l'image sélectionnée
document.addEventListener('DOMContentLoaded', function() {
  const selectedIndex = sessionStorage.getItem('selectedImageIndex');
  
  if (selectedIndex !== null) {
    // Nettoyer le storage
    sessionStorage.removeItem('selectedImageIndex');
    
    // Chercher les miniatures ou boutons de la galerie produit
    setTimeout(function() {
      const thumbnails = document.querySelectorAll('.product__thumb');
      if (thumbnails[selectedIndex]) {
        thumbnails[selectedIndex].click();
      }
    }, 500);
  }
});

/**
 * AMÉLIORATIONS FUTURES
 * --------------------
 * Cet espace est réservé pour les futures fonctionnalités JavaScript.
 * 
 * Idées potentielles:
 * - Amélioration du panier d'achat
 * - Fonctionnalités pour le programme de fidélité
 * - Améliorations de la navigation mobile
 */